export default __webpack_public_path__ + "static/media/bean-3.ee9ec63e.png";